<!-- Preloader Start -->
<div class="ct-preloader">
<div class="ct-preloader-inner">
    <div class="lds-ripple"><div></div><div></div></div>
</div>
</div>
<!-- Preloader End -->